var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary px-4 ml-3",attrs:{"type":"button"},on:{"click":_vm.openMFAModal}},[_vm._v(" "+_vm._s(_vm.user.mfa_active ? "Disable" : "Enable")+" ")]),_c('ToggleMultiFactorAuthModal',{attrs:{"id":'toggleMfa',"closeModal":_vm.closeModal,"refresh":_vm.refresh,"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }